import IconCopySolid from '@/assets/icons/font_awesome/copy-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTOWorkspaceUserInvitation } from '@shared/dto/+workspace/workspace_user_invitation/dto_workspace_user_invitation';
import { useTranslation } from 'react-i18next';

interface Props {
  item: DTOWorkspaceUserInvitation;
}

export function WButtonUserInvitationCopyLink({ item }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  async function onClick() {
    await navigator.clipboard.writeText(ENUM__page_type.BUILD_FULL_PATH_WORKSPACE_INVITATION(item.token));

    toast({ title: t(i18n_base_ui.toasts.button_user_invitation_copy_link.title) });
  }

  if (item.rejected_at != CONSTANTS__shared.NUMBER_EMPTY_VALUE) return <PLACEHOLDER_BUTTON__bar />;
  if (item.accepted_at != CONSTANTS__shared.NUMBER_EMPTY_VALUE) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={'Copy link to clipboard'}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-component'}
        iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
        iconClassNameHovered="!text-bar-foreground"
        Icon={IconCopySolid}
        {...{ onClick }}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
